import React, { useEffect } from "react";
import { Spinner } from "react-bootstrap";

const Loading = () => {
  return (
    <div style={styles.container}>
      <Spinner animation="grow" variant="success" />
    </div>
  );
};

const styles = {
  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
  },
};
export default Loading;
